<mat-form-field [ngClass]='{"w-100":maxWidthNeeded}'>
  <mat-label *ngIf='labelNeeded' for='autocompleteInput'>Location</mat-label>
  <mat-autocomplete id='autocomplete'
                    #auto='matAutocomplete'
                    (optionSelected)='handleAddressChange($event, selectedItem.calculationResult?.testId)'
                    [displayWith]='displayFn.bind(this)'>
    <small [hidden]='filteredUserSavedPlaces && !filteredUserSavedPlaces[0]'
           class='font-weight-bold p-2'>Recent Places:</small>
    <div class='selection-div row p-1' *ngFor='let place of filteredUserSavedPlaces'>
      <mat-option class='col-lg-10 col-8' [value]='place'>
        {{place.name}}
        <span [hidden]='place.formatted_address === ""'>| <small
          class='dark-grey-text'>{{place.formatted_address}}</small></span>
      </mat-option>
      <button class='btn btn-outline-danger mx-auto' (mousedown)='deletePlace($event)'
              [value]='place.place_id'>
        <!--      <mdb-icon fas icon='minus'></mdb-icon>-->
        <i class='fas fa-trash-alt'></i>
      </button>
    </div>
    <hr
      [hidden]='predictionsArray && !predictionsArray[0] || filteredUserSavedPlaces && !filteredUserSavedPlaces[0]'>
    <small [hidden]='predictionsArray && !predictionsArray[0]'
           class='font-weight-bold p-2'>Google Results:</small>
    <div class='selection-div row p-1'
         *ngFor='let prediction of predictionsArray'>
      <mat-option
        [ngClass]="{
      'col-12': prediction.place_id && !prediction.isSaving && !prediction.isSaved,
      'col-11': prediction.place_id && !prediction.isSaving && prediction.isSaved
      }"
        [value]='prediction'>
        {{prediction.description}}
      </mat-option>
      <mdb-icon *ngIf='prediction.place_id && !prediction.isSaving && prediction.isSaved' fas
                icon='heart' size='large' class='m-auto blue-text'></mdb-icon>
    </div>
    <div
      [hidden]='lastTypedValue === undefined || this.lastTypedValue === "" || this.lastTypedValue === this.selectedItem.location?.name || this.lastTypedValue === this.selectedItem.location?.formatted_address || this.isDuplicatePlace'>
      <hr>
      <mat-option
        class='col-12'
        [value]='{"name":this.lastTypedValue, "place_id":"custom_place"}'>
        <div>
          <mdb-icon fas icon='plus' class='blue-text mr-1'></mdb-icon>
          {{"Add unlisted location: \"" + this.lastTypedValue + "\""}}
        </div>
      </mat-option>
    </div>
  </mat-autocomplete>
  <div class='d-flex'>
    <!--suppress AngularUndefinedBinding -->
    <input type='text'
           aria-label='Location'
           matInput
           id='autocompleteInput'
           autocomplete='off'
           #inputField
           [ngStyle]="{'min-width': widthNeeded ? '20em' : null }"
           (keyup.enter)='handleLocationChangeManual($event,selectedItem.calculationResult?.testId)'
           (focus)='inputFocus($event)'
           (blur)='handleLocationChangeManual($event,selectedItem.calculationResult?.testId)'
           [ngModel]='selectedItem.location ? selectedItem.location.formatted_address ? selectedItem.location.formatted_address : selectedItem.location : null'
           [matAutocomplete]='auto' name='txtPredictionsSelect'
           (ngModelChange)='handleLocationInputChange($event)'
           [value]='this.lastTypedValue'
           class='d-inline col-10 col-lg-11'>
    <button class='btn clear-button' type='button' mat-button matSuffix
            mat-icon-button
            [hidden]='!showLocationClear' aria-label='Clear' *ngIf='this.lastTypedValue && clearNeeded'
            (click)='this.clearLocationInput()'>
      <mat-icon>close</mat-icon>
    </button>
  </div>
</mat-form-field>
